<style lang="scss">
  @import "quick-configuration";
</style>

<script>
import { CONSTANT, LOCALES } from '../../../utils/constant'
import sharedService from '../../../utils/shared-service'

export default {
  data () {
    return {
      constants: CONSTANT,
      localeValidationError: false,
      isOtherLocale: false,
      otherLocale: '',
      localLocale: '',
      localShippingAddress: '',
      localBillingAddress: '',
      localDPATransactionOptions: {},
      localPayloadTypeIndicatorCheckout: '',
      localPayloadTypeIndicatorPayload: '',
      localEnvironment: '',
      selectedEnvironment: '',
      allEnvironments: '',
      localMaCryptoOption: '',
      locales: LOCALES
    }
  },

  mounted () {
    this.resetConfiguration()
  },

  methods: {

    /**
     * select locale and check for Others
     * @param selectedLocale
     */
    selectLocale (selectedLocale = this.localLocale) {
      this.localeValidationError = false
      if (selectedLocale === CONSTANT.CONFIG.OTHER_LOCALE) {
        this.isOtherLocale = true
        this.otherLocale = this.$store.getters.otherLocale || ''
      } else {
        this.isOtherLocale = false
        this.otherLocale = ''
      }
    },

    /**
     * check preferred locale and update if valid
     * @param locale
     */
    validateLocale (locale) {
      const pattern = /^[a-z]{2}_[A-Z]{2}$/
      if (!pattern.test(locale)) {
        this.localeValidationError = true
        return false
      } else {
        this.localeValidationError = false
        return true
      }
    },

    /**
     * Save updated configuration
     */
    SaveConfiguration () {
      this.$store.commit('updateShippingAddress', this.localShippingAddress)
      this.$store.commit('updateBillingAddress', this.localBillingAddress)
      this.$store.commit('updatePayloadTypeIndicatorCheckout', this.localPayloadTypeIndicatorCheckout)
      this.$store.commit('updatePayloadTypeIndicatorPayload', this.localPayloadTypeIndicatorPayload)
      this.$store.commit('changeLocale', this.localLocale)
      this.$store.commit('updateDSATransactionOptions', Object.assign({}, this.localDPATransactionOptions))
      this.$store.commit('changeOtherLocale', this.otherLocale)
      this.$store.commit('updateDynamicDataTypeMastercard', this.localMaCryptoOption)
      sharedService.updateCheckoutButton(false)
      if (this.selectedEnvironment !== this.localEnvironment) {
        localStorage.setItem('setEnv', this.selectedEnvironment)
        window.location.reload()
      }
      (this.$router.currentRoute.name === 'Cart') && window.location.reload()
      this.$emit('closeConfig')
    },

    /**
     * Reset all configuration to default
     */
    resetConfiguration () {
      this.localEnvironment = localStorage.getItem('setEnv') || CONSTANT.CONFIG.ENVIRONMENT.SANDBOX
      this.selectedEnvironment = localStorage.getItem('setEnv') || CONSTANT.CONFIG.ENVIRONMENT.SANDBOX
      this.allEnvironments = this.$store.getters.allEnvironments || []
      this.localLocale = this.$store.getters.locale || 'en_US'
      this.localShippingAddress = this.$store.getters.shippingAddress
      this.localBillingAddress = this.$store.getters.billingAddress
      this.localDPATransactionOptions = Object.assign({}, this.$store.getters.dsaTransactionOptions)
      this.localPayloadTypeIndicatorCheckout = this.$store.getters.payloadTypeIndicatorCheckout
      this.localPayloadTypeIndicatorPayload = this.$store.getters.payloadTypeIndicatorPayload
      this.localMaCryptoOption = this.$store.getters.dynamicDataTypeMastercard || CONSTANT.TOKENIZATION_OPTIONS.MASTERCARD['UCAF - CARD APPLICATION CRYPTOGRAM SHORT FORM']
      this.selectLocale()
    },

    /**
     * Load config based on environment selection
     * @param environmentId
     */
    loadEnvironmentConfigurations (environmentId) {
      localStorage.setItem('setEnv', environmentId)
    }
  }

}
</script>
<template>
  <div id="quickConfig">
    <div class="wrapper col-xs-12 col-sm-8 col-md-6 col-lg-4">
      <h4>
        <span class="quick-config-logo">
          <i class="fa fa-cog" />
        </span>
        <span class="font-weight-bold text-dark">
          {{ $t ('header.quickConfiguration') }}
        </span>
        <span
          class="quick-config-close-btn pull-right mt-4"
          @click="$emit('closeConfig')"
        />
      </h4>
    </div>
    <div class="content col-xs-12 col-sm-8 col-md-6 col-lg-4">
      <div class="config-body">
        <div class="form-group">
          <h5
            class="font-weight-bold"
            for="environmentSelection"
          >
            {{ $t ('header.selectEnvironment') }}
          </h5>
          <select
            v-model="selectedEnvironment"
            class="form-control form-control-sm"
          >
            <option
              v-for="env in allEnvironments"
              :key="env"
              :value="env"
            >
              {{ env }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <h5
            class="font-weight-bold"
            for="locale"
          >
            {{ $t ('header.locale') }}
          </h5>
          <select
            id="locale"
            v-model="localLocale"
            class="form-control form-control-sm"
            data-test="locale"
            @change="selectLocale(localLocale)"
          >
            <option
              v-for="localeObj in locales"
              :key="localeObj.label"
              :disabled="localeObj.separator"
              :value="localeObj.value"
            >
              {{ localeObj.label }}
            </option>
          </select>
          <input
            v-if="isOtherLocale"
            id="preferredLocale"
            v-model.trim="otherLocale"
            :class="{'border-danger': localeValidationError}"
            class="form-control form-control-sm mt-2"
            data-test="preferredLocale"
            placeholder="Preferred Locale"
            type="text"
            @change="validateLocale(otherLocale)"
          >
          <small
            v-if="localeValidationError"
            id="localeValidationError"
            class="text-danger"
          >
            {{ $t ('errorMessages.invalidLocale') }}
          </small>
        </div>
        <div class="form-group">
          <h5
            class="font-weight-bold"
            for="shippingAddress"
          >
            {{ $t ('header.shippingAddressPreference') }}
          </h5>
          <select
            id="shippingAddress"
            :data-selected="localShippingAddress"
            v-model="localShippingAddress"
            class="form-control form-control-sm"
            data-test="Shipping Address"
          >
            <option
              v-for="(key, value) in constants.CONFIG.SHIPPING_ADDRESS"
              :key="key"
              :value="key"
            >
              {{ value }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <h5
            class="font-weight-bold"
            for="billingAddress"
          >
            {{ $t ('header.billingAddressPreference') }}
          </h5>
          <select
            id="billingAddress"
            :data-selected="localBillingAddress"
            v-model="localBillingAddress"
            class="form-control form-control-sm"
            data-test="Billing Address"
          >
            <option
              v-for="(key, value) in constants.CONFIG.BILLING_ADDRESS"
              :key="key"
              :value="key"
            >
              {{ value }}
            </option>
          </select>
        </div>
        <div class="form-group d-none">
          <h5
            class="font-weight-bold"
            for="payloadIndicatorCheckout"
          >
            {{ $t ('label.payloadIndicatorCheckout')
            }}
          </h5>
          <select
            id="payloadIndicatorCheckout"
            :data-selected="localPayloadTypeIndicatorCheckout"
            v-model="localPayloadTypeIndicatorCheckout"
            class="form-control form-control-sm"
            data-test="Payload Indicator Checkout"
          >
            <option
              v-for="(key, value) in constants.CONFIG.PAYLOAD_RETRIEVAL_TYPES"
              :key="key"
              :value="key"
            >
              {{ value }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <h5
            class="font-weight-bold"
            for="payloadIndicatorPayload"
          >
            {{ $t ('label.payloadIndicatorPayload')
            }}
          </h5>
          <select
            id="payloadIndicatorPayload"
            :data-selected="localPayloadTypeIndicatorPayload"
            v-model="localPayloadTypeIndicatorPayload"
            class="form-control form-control-sm"
            data-test="Payload Indicator Payload"
          >
            <option
              v-for="(key, value) in constants.CONFIG.PAYLOAD_RETRIEVAL_TYPES"
              :key="key"
              :value="key"
            >
              {{ value }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <h5 class="font-weight-bold">
            {{ $t ('header.MastercardCryptoOption') }}
          </h5>
          <select
            id="mastercardCryptoOption"
            :data-selected="localMaCryptoOption"
            v-model="localMaCryptoOption"
            class="form-control form-control-sm"
            data-test="Mastercard Crypto Option"
          >
            <option
              v-for="(key, value) in constants.TOKENIZATION_OPTIONS.MASTERCARD"
              :key="value"
              :value="key"
            >
              {{ value }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <h5 class="font-weight-bold">
            {{ $t ('header.consumerProfilePreference') }}
          </h5>
          <div>
            <div
              v-for="(key,value) in constants.CONFIG.CONSUMER_PROFILE_PREFERENCES"
              :key="key"
              class="form-check form-check-inline"
            >
              <input
                :id="'consumerProfile' + key"
                v-model="localDPATransactionOptions[key]"
                :data-test="'checkbox-' + key"
                :checked="localDPATransactionOptions[key]"
                class="form-check-input"
                type="checkbox"
              >
              <label
                :for="'consumerProfile' + key"
                class="form-check-label"
              >{{ value }}
              </label>
            </div>
          </div>
        </div>
        <button
          class="btn border-primary text-primary btn-block"
          @click="resetConfiguration"
        >
          Reset
        </button>
        <button
          :class="[localeValidationError ? 'disabled btn-secondary' : 'btn-primary not-disabled']"
          :disabled="localeValidationError"
          class="btn btn-primary btn-block mb-3"
          @click="SaveConfiguration"
        >
          {{ $t ('label.saveConfiguration') }}
        </button>
      </div>
    </div>
  </div>
</template>
